import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Modal from "react-bootstrap/Modal";
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";
function LocationComp() {
  const pagination = useRef();
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  const userId = localStorage.getItem('userId');
  useEffect(() => {
    getLocation(1)
  }, [])
  const [locationlist, setLocationlist] = useState([])
  const [perPage, setPerpage] = useState('');
  const [totalitem, setTotalitem] = useState(0);
  const [modalstatus, setModalstatus] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setSmg] = useState('');
  const [location, setLocation] = useState('');
  const [timezone, setTimezone] = useState('');
  const [errl, setErrl] = useState('')
  const [errt, setErrt] = useState('')

  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
  const hr_permission = get_oermission_data.login_Permission.permissions

  const hr_permission_arr = Array()
  if (hr_permission) {
    const hr_permission_arr1 = JSON.parse(hr_permission).split(",")
    hr_permission_arr1.map((item, ind) => {
      hr_permission_arr.push(item);
    })
  }


  const setPage = ({ selected }) => {
    getLocation(selected + 1);
  }
  const getLocation = async (page) => {
    const response = await fetch(SERVER_URL + `api/location/location-list?page=${page == 'undefined' ? 1 : page}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        if (data.status == true) {
          // console.log(data)
          setLocationlist(data.data)
          setTotalitem(data.locationTotal);
          setPerpage(data.limit)
        }


      })
  }


  const handleDelete = (id) => {
    const response = fetch(SERVER_URL + `api/location/location-delete`,
      {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
          locationId: id,
          requestedBy: userId
        }),
      }).then(res => res.json())
      .then(data => {
        if (data.status = true) {
          getLocation(1)
        }
      })
  }
  const showModal = () => {
    setModalstatus(true)
  }
  const handleClose = () => {
    setId('')
    setErrl('')
    setErrt('')
    setErr('')
    setSmg('')
    setLocation('')
    setTimezone('')
    setModalstatus(false)
  }

  const Ref_location = useRef()
  const Ref_timezone = useRef()
  const handleSaveLocation = () => {
    setErrl('')
    setErrt('')
    const RegExp = /^(?!\s).+(?<!\s)$/gm
    const RegExpl = /^(?!\s).+(?<!\s)$/gm
    if (!RegExp.test(location)) {
      setErrl('red')
      Ref_location.current.focus()
      return false;
    } else if (!RegExpl.test(timezone)) {
      setErrt('red')
      Ref_timezone.current.focus()
      return false;
    } else {
      if (id != '') {
        const response = fetch(SERVER_URL + `api/location/location-update`,
          {
            method: 'put',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
              locationId: id,
              name: location,
              timezone: timezone,
              requestedBy: userId
            }),
          }).then(res => res.json())
          .then(data => {
            setSmg('Timezone edit successfully')
            setErr('green')
            setTimeout(function () {
              getLocation()
              setSmg('')
              handleClose()

            }, 1000);

          })
      } else {
        const response = fetch(SERVER_URL + `api/location/add-location`,
          {
            method: 'post',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
              name: location,
              timezone: timezone,
              requestedBy: userId
            }),
          }).then(res => res.json())
          .then(data => {
            setSmg('Timezone add successfully')
            setErr('green')
            setTimeout(function () {
              getLocation()
              setSmg('')
              handleClose()

            }, 1000);
          })
      }

    }

  }
  const [id, setId] = useState('');
  const getholidayById = (id) => {
    setId(id)
    const response = fetch(SERVER_URL + `api/location/location-edit`,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
          locationId: id
        }),
      })
      .then(res => res.json())
      .then(data => {
        if (data.status == true) {
          var resdata = data.data
          setLocation(resdata.name)
          setTimezone(resdata.timezone)
          setModalstatus(true)
        }
      })
  }
  return (
    <>
      <Modal show={modalstatus} size="md" id="confirm_login">
        <div className="modal-body">
          <div className="decorative-shape shape-1"></div>
          <div className="decorative-shape shape-2"></div>
          <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
            <i className="icon icon-cross fw-bold"></i>
          </button>
          <div className="dash_white_box_ttl text-center" id="exampleModalLabel"> {id ? 'Edit' : 'Add'} Location</div>
          <div className="mb-2">
            <label className="col-form-label">Location {errl}</label>
            <input type="text" ref={Ref_location} style={{ 'border-color': `${errl}` }} onChange={(e) => { setLocation(e.target.value) }} value={location} className="form-control" placeholder="" />
          </div>
          <div className="mb-3">
            <label className="col-form-label">Time Zone</label>
            <input type="text" ref={Ref_timezone} style={{ 'border-color': `${errt}` }} onChange={(e) => { setTimezone(e.target.value) }} value={timezone} className="form-control" placeholder="" />
          </div>
          <div className="modalfooter">
            <span className="d-block text-right mb10" style={{ color: err }}>{msg}</span>
            <div className="row">
              <div className="col-md-6 pr07">
                <button type="button" onClick={handleSaveLocation} className="btn_5 w-100">Save</button>
              </div>
              <div className="col-md-6 pl07">
                <button type="button" onClick={handleClose} className="btn_6 w-100" data-bs-dismiss="modal">Cancel</button>
              </div>
            </div>



          </div>
        </div>

      </Modal>
      <div className="page-header">
        <h1>
          Location
          {
            (hr_permission_arr?.includes('44') && <button href="" className="btn_5 mr10 float-end" onClick={showModal}>Add Location</button>)
          }
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li className="current">
            <span>/</span> Location
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <table className="table_style_1">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Location</th>
              <th>TimeZone</th>
              <th>Status</th>
              <th style={{ width: "150px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              locationlist?.map((row, ind) =>
                <tr key={ind + 1}>
                  <td>
                    {ind + 1}
                  </td>
                  <td>
                    {row.name}
                  </td>
                  <td>
                    {row.timezone}
                  </td>
                  <td>
                    {row?.status == 1 ? 'Active' : 'Inactive'}
                  </td>
                  <td>
                    {
                      (hr_permission_arr?.includes('45') && <button onClick={(e) => { getholidayById(row.location_id) }} className="btn_7 mr03">Edit</button>)
                    }
                    {
                      (hr_permission_arr?.includes('46') && <button onClick={(e) => { handleDelete(row.location_id) }} className="btn_8">Delete</button>)
                    }
                  </td>
                </tr>
              )
            }

          </tbody>
          <tfoot>
            <tr><td colSpan="8" >
              <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
              <ReactPaginate
                ref={pagination}
                // pageCount={Math.ceil(totalitem / perPage)}
                 pageCount={perPage > 0 ? Math.ceil((totalitem || 0) / perPage) : 0}
                pageRangeDisplayed={4}
                marginPagesDisplayed={1}
                onPageChange={setPage}
                containerClassName="pagination"
                activeClassName="active"
                pageLinkClassName="page-link"
                breakLinkClassName="page-link"
                nextLinkClassName="page-link"
                previousLinkClassName="page-link"
                pageClassName="page-item"
                breakClassName="page-item"
                nextClassName="page-item"
                previousClassName="page-item"
                previousLabel={<>&laquo;</>}
                nextLabel={<>&raquo;</>}
              />
            </td></tr>
          </tfoot>
        </table>
      </div>
    </>
  )
}

export default LocationComp
